export const MOCK_METER_DETAILS = {
  entity: {
    ma_lo_id: 'DE852287503',
    meter_type: 'electronic-meter',
    tariff_type: 'et',
    meter_number: 'MTR2YS7890',
    sector: 'power',
    used_for: 'Haushaltsstrom',
    manufacturer: 'Sagemcom',
    calibration_date: '2025-01-01',
    location: 'Keller Oben Mitte',
    status: 'active',
    _tags: ['dont-touch'],
    _schema: 'meter',
    _id: 'e250a873-fe35-4b24-b502-19a84347200d',
    _org: 'test-org',
    _created_at: '2025-05-19T11:40:47.144Z',
    _title: 'MTR2YS7890',
    counters: {
      $relation: [
        {
          entity_id: 'c2dd7872-6ac0-4d7c-85a2-8f7775315832',
          _tags: []
        }
      ]
    },
    contract: {
      $relation: [
        {
          entity_id: 'a68e4801-979c-4fee-b43f-0dbacb06634e'
        },
        {
          entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
        }
      ]
    },
    customer: {
      $relation: [
        {
          entity_id: '6fd04058-92c9-43bc-ab10-29a2d6808be3',
          _schema: 'contact',
          _tags: []
        }
      ]
    },
    _files: {
      $relation: [
        {
          entity_id: 'a18a9f26-d973-48b6-9b1c-27341f0f17ff'
        }
      ]
    },
    _updated_at: '2025-06-17T11:11:36.771Z'
  },
  relations: [
    {
      obis_number: '1-0:1.8.0',
      direction: 'feed-out',
      tariff_type: 'et',
      transformer_ratio: '1',
      unit: 'kWh',
      conversion_factor: '1.0',
      _tags: ['dont-touch'],
      _schema: 'meter_counter',
      _id: 'c2dd7872-6ac0-4d7c-85a2-8f7775315832',
      _org: 'test-org',
      _created_at: '2025-05-19T11:39:05.748Z',
      _updated_at: '2025-05-19T11:51:40.726Z',
      _title: '1-0:1.8.0'
    },
    {
      filename: 'Ablesung 2025-06-10T11:21:21+02:00.jpg',
      document_type: 'image',
      access_control: 'private',
      shared_with_end_customer: true,
      type: 'image',
      public_url:
        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/835f4a8f-543e-4246-9011-dcebc41c987c/Ablesung%25202025-06-10T11%253A21%253A21%252B02%253A00.jpg',
      size_bytes: 4303,
      readable_size: '4.2 KB',
      mime_type: 'image/png',
      width: 119,
      height: 267,
      s3ref: {
        bucket: 'epilot-prod-user-content',
        key: '16246022/835f4a8f-543e-4246-9011-dcebc41c987c/Ablesung%202025-06-10T11%3A21%3A21%2B02%3A00.jpg'
      },
      versions: [
        {
          filename: 'Ablesung 2025-06-10T11:21:21+02:00.jpg',
          document_type: 'image',
          access_control: 'private',
          shared_with_end_customer: true,
          type: 'image',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/835f4a8f-543e-4246-9011-dcebc41c987c/Ablesung%25202025-06-10T11%253A21%253A21%252B02%253A00.jpg',
          size_bytes: 4303,
          readable_size: '4.2 KB',
          mime_type: 'image/png',
          width: 119,
          height: 267,
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/835f4a8f-543e-4246-9011-dcebc41c987c/Ablesung%202025-06-10T11%3A21%3A21%2B02%3A00.jpg'
          }
        }
      ],
      _schema: 'file',
      _id: 'a18a9f26-d973-48b6-9b1c-27341f0f17ff',
      _org: 'test-org',
      _created_at: '2025-06-10T09:21:22.434Z',
      _updated_at: '2025-06-10T09:21:22.434Z',
      _title: 'Ablesung 2025-06-10T11:21:21+02:00.jpg'
    },
    {
      contract_name: 'Max Spark Dynamic Green+',
      contract_number: '589010218',
      account_number: '',
      move_in_date: '2025-05-01',
      type: 'recurring',
      installment_amount: 20000,
      installment_amount_currency: 'EUR',
      installment_amount_decimal: '200.00',
      balance: 0,
      balance_currency: 'EUR',
      balance_decimal: '0.00',
      _schema: 'contract',
      _id: '78d3639c-ef63-4517-9942-3407dda87de7',
      _org: 'test-org',
      _created_at: '2025-05-07T07:58:32.296Z',
      _updated_at: '2025-06-17T11:11:37.632Z',
      status: 'active',
      billing_period: 'monthly',
      billing_duration_unit: 'months',
      notice_time_unit: 'months',
      termination_time_unit: 'months',
      renewal_duration_unit: 'months',
      _title: 'Max Spark Dynamic Green+',
      meters: {
        $relation: [
          {
            entity_id: '3c95352d-32e2-486d-9991-d565f3b84e11',
            _tags: []
          }
        ]
      },
      customer: {
        $relation: [
          {
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            _schema: 'contact',
            _tags: []
          }
        ]
      },
      line_items: [
        {
          price_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
          product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
          quantity: 1,
          description: 'Dynamic Green+',
          unit_amount: 0,
          unit_amount_decimal: '0.00',
          pricing_model: 'per_unit',
          item_components: [
            {
              price_id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
              product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
              quantity: 1,
              description: 'Grundpreis',
              unit_amount: 0,
              unit_amount_decimal: '1.3e-9',
              pricing_model: 'tiered_volume',
              _price: {
                _id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
                _manifest: [
                  '3babbfe8-80a2-4e19-b9e6-3d6d4fa22730',
                  '50fb9921-3b0d-430a-9211-5b741e601008',
                  '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                  '4573c148-9fa1-4de8-bb05-964a01690789'
                ],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _tags: ['Commodity', 'Strom'],
                active: true,
                description: 'Grundpreis',
                is_tax_inclusive: true,
                price_display_in_journeys: 'show_price',
                pricing_model: 'tiered_volume',
                tax: [
                  {
                    _manifest: [
                      '956e9f44-0d8e-4d50-af85-e528fb130d64',
                      'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                      '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                      '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                      '4573c148-9fa1-4de8-bb05-964a01690789'
                    ],
                    _schema: 'tax',
                    active: true,
                    description: '19%',
                    rate: '19',
                    region: 'DE',
                    type: 'VAT',
                    _id: '170d696a-611a-4627-a904-137741027989',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:09:29.464Z',
                    _updated_at: '2025-04-04T07:57:19.848Z',
                    _title: '19%',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    }
                  }
                ],
                tiers: [],
                type: 'recurring',
                unit_amount: 1300,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '13',
                variable_price: true,
                billing_duration_amount: '',
                billing_duration_unit: null,
                billing_period: 'monthly',
                internal_description: 'Grundpreis',
                notice_time_amount: null,
                notice_time_unit: null,
                price_components: null,
                renewal_duration_amount: null,
                renewal_duration_unit: null,
                termination_time_amount: null,
                termination_time_unit: null,
                _title: 'Grundpreis',
                averageMarketPrice: {
                  market: 'day_ahead',
                  bidding_zone: 'DE-LU',
                  price: {
                    timestamp:
                      '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
                    unit_amount: 7.79,
                    unit_amount_decimal: '0.0779',
                    unit_amount_currency: 'EUR'
                  },
                  _meta: {
                    timestamp: 1747981644144,
                    signature:
                      'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
                  },
                  inputs: {
                    market: 'day_ahead',
                    bidding_zone: 'DE-LU',
                    from: '2025-04-01',
                    to: '2025-04-30'
                  }
                }
              },
              _product: {
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _tags: ['Commodity', 'Strom', 'dont-touch'],
                active: true,
                categories: [],
                description: 'Außerhalb der Grundversorgung',
                feature: [
                  {
                    _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                    _tags: [],
                    feature: '100% Ökostrom',
                    value: ''
                  },
                  {
                    _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                    _tags: [],
                    feature: 'Erstlaufzeit bis 31.12.2025',
                    value: ''
                  },
                  {
                    _id: 'SbRtgtY6flxvlR1M-LaHi',
                    _tags: [],
                    feature: 'Kündigungsfrist 1 Monat',
                    value: ''
                  },
                  {
                    _id: 'v07rw_RfinlcUOfQD0h9S',
                    _tags: [],
                    feature:
                      '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                    value: ''
                  }
                ],
                internal_name: 'Strom Green+',
                name: 'Strom Green+',
                price_options: [
                  {
                    _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _schema: 'price',
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    description: 'Classic Green+',
                    is_composite_price: true,
                    is_tax_inclusive: null,
                    price_components: [],
                    price_display_in_journeys: 'show_price',
                    pricing_model: null,
                    tiers: [],
                    type: null,
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: null,
                    billing_duration_amount: null,
                    billing_duration_unit: null,
                    billing_period: null,
                    internal_description: 'Classic Green+',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    unit: null,
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:27.709Z',
                    _updated_at: '2025-05-23T06:23:55.130Z',
                    _title: 'Classic Green+',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    $relation: {
                      entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                    }
                  },
                  {
                    _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _schema: 'price',
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    billing_duration_unit: 'months',
                    description: 'Dynamic Green+',
                    is_composite_price: true,
                    is_tax_inclusive: true,
                    notice_time_unit: 'months',
                    price_components: [],
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    renewal_duration_unit: 'months',
                    termination_time_unit: 'months',
                    tiers: [],
                    type: 'one_time',
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: false,
                    billing_period: 'weekly',
                    internal_description: 'Dynamic Green+',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:27.918Z',
                    _updated_at: '2025-05-23T06:24:15.056Z',
                    _title: 'Dynamic Green+',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    $relation: {
                      entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                    }
                  }
                ],
                product_downloads: [
                  {
                    _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Datenschutz'],
                    _title: 'Datenschutzinformationen.pdf',
                    access_control: 'public-read',
                    filename: 'Datenschutzinformationen.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:20.522Z',
                    _updated_at: '2025-04-04T07:57:21.022Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                    $relation: {
                      entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                    }
                  },
                  {
                    _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'AGB'],
                    _title: 'AGB.pdf',
                    access_control: 'public-read',
                    filename: 'AGB.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:21.247Z',
                    _updated_at: '2025-04-04T07:57:21.704Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                    $relation: {
                      entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                    }
                  },
                  {
                    _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Widerrufsformular'],
                    _title: 'Muster-Widerrufsformular.pdf',
                    access_control: 'public-read',
                    filename: 'Muster-Widerrufsformular.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:21.101Z',
                    _updated_at: '2025-04-04T07:57:21.569Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                    $relation: {
                      entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                    }
                  },
                  {
                    _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Preisblatt'],
                    _title: 'Preisblatt.pdf',
                    access_control: 'public-read',
                    filename: 'Preisblatt.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:20.386Z',
                    _updated_at: '2025-04-04T07:57:20.823Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                    $relation: {
                      entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                    }
                  }
                ],
                product_images: [],
                type: 'product',
                _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                _title: 'Strom Green+',
                _messages: {}
              },
              taxes: [
                {
                  tax: {
                    _manifest: [
                      '956e9f44-0d8e-4d50-af85-e528fb130d64',
                      'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                      '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                      '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                      '4573c148-9fa1-4de8-bb05-964a01690789'
                    ],
                    _schema: 'tax',
                    active: true,
                    description: '19%',
                    rate: '19',
                    region: 'DE',
                    type: 'VAT',
                    _id: '170d696a-611a-4627-a904-137741027989',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:09:29.464Z',
                    _updated_at: '2025-04-04T07:57:19.848Z',
                    _title: '19%',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    }
                  },
                  amount: 0
                }
              ],
              type: 'recurring',
              billing_period: 'monthly',
              tiers_details: [
                {
                  quantity: 0,
                  unit_amount: 0,
                  unit_amount_decimal: '0',
                  unit_amount_net: 0,
                  unit_amount_gross: 0,
                  amount_subtotal: 0,
                  amount_total: 0,
                  amount_tax: 0
                }
              ],
              unit_amount_gross: 0,
              unit_amount_net: 0,
              amount_subtotal: 0,
              amount_total: 0,
              amount_tax: 0,
              currency: 'EUR',
              is_tax_inclusive: true,
              unit_amount_net_decimal: '0',
              unit_amount_gross_decimal: '0',
              amount_subtotal_decimal: '0',
              amount_total_decimal: '0'
            },
            {
              price_id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
              product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
              quantity: 1,
              description: 'Energie Spotmarktpreis',
              unit_amount: 24,
              unit_amount_decimal: '0.243801',
              pricing_model: 'dynamic_tariff',
              _price: {
                _id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _tags: ['Commodity', 'Strom'],
                active: true,
                billing_duration_unit: 'months',
                description: 'Energie Spotmarktpreis',
                is_tax_inclusive: true,
                notice_time_unit: 'months',
                price_display_in_journeys: 'show_price',
                pricing_model: 'dynamic_tariff',
                renewal_duration_unit: 'months',
                tax: [
                  {
                    _manifest: [
                      '956e9f44-0d8e-4d50-af85-e528fb130d64',
                      'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                      '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                      '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                      '4573c148-9fa1-4de8-bb05-964a01690789'
                    ],
                    _schema: 'tax',
                    active: true,
                    description: '19%',
                    rate: '19',
                    region: 'DE',
                    type: 'VAT',
                    _id: '170d696a-611a-4627-a904-137741027989',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:09:29.464Z',
                    _updated_at: '2025-04-04T07:57:19.848Z',
                    _title: '19%',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    }
                  }
                ],
                termination_time_unit: 'months',
                tiers: [],
                type: 'recurring',
                unit: 'kwh',
                unit_amount: 0,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0.00',
                variable_price: true,
                billing_period: 'monthly',
                dynamic_tariff: {
                  interval: 'hourly',
                  markup: 0,
                  markup_amount: 15,
                  markup_amount_decimal: '0.1511',
                  markup_decimal: '0.00',
                  mode: 'day_ahead_market'
                },
                internal_description: 'Energie Spotmarktpreis',
                _title: 'Energie Spotmarktpreis',
                averageMarketPrice: {
                  market: 'day_ahead',
                  bidding_zone: 'DE-LU',
                  price: {
                    timestamp:
                      '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
                    unit_amount: 7.79,
                    unit_amount_decimal: '0.0779',
                    unit_amount_currency: 'EUR'
                  },
                  _meta: {
                    timestamp: 1747981644144,
                    signature:
                      'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
                  },
                  inputs: {
                    market: 'day_ahead',
                    bidding_zone: 'DE-LU',
                    from: '2025-04-01',
                    to: '2025-04-30'
                  }
                }
              },
              _product: {
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _tags: ['Commodity', 'Strom', 'dont-touch'],
                active: true,
                categories: [],
                description: 'Außerhalb der Grundversorgung',
                feature: [
                  {
                    _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                    _tags: [],
                    feature: '100% Ökostrom',
                    value: ''
                  },
                  {
                    _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                    _tags: [],
                    feature: 'Erstlaufzeit bis 31.12.2025',
                    value: ''
                  },
                  {
                    _id: 'SbRtgtY6flxvlR1M-LaHi',
                    _tags: [],
                    feature: 'Kündigungsfrist 1 Monat',
                    value: ''
                  },
                  {
                    _id: 'v07rw_RfinlcUOfQD0h9S',
                    _tags: [],
                    feature:
                      '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                    value: ''
                  }
                ],
                internal_name: 'Strom Green+',
                name: 'Strom Green+',
                price_options: [
                  {
                    _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _schema: 'price',
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    description: 'Classic Green+',
                    is_composite_price: true,
                    is_tax_inclusive: null,
                    price_components: [],
                    price_display_in_journeys: 'show_price',
                    pricing_model: null,
                    tiers: [],
                    type: null,
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: null,
                    billing_duration_amount: null,
                    billing_duration_unit: null,
                    billing_period: null,
                    internal_description: 'Classic Green+',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    unit: null,
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:27.709Z',
                    _updated_at: '2025-05-23T06:23:55.130Z',
                    _title: 'Classic Green+',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    $relation: {
                      entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                    }
                  },
                  {
                    _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _schema: 'price',
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    billing_duration_unit: 'months',
                    description: 'Dynamic Green+',
                    is_composite_price: true,
                    is_tax_inclusive: true,
                    notice_time_unit: 'months',
                    price_components: [],
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    renewal_duration_unit: 'months',
                    termination_time_unit: 'months',
                    tiers: [],
                    type: 'one_time',
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: false,
                    billing_period: 'weekly',
                    internal_description: 'Dynamic Green+',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:27.918Z',
                    _updated_at: '2025-05-23T06:24:15.056Z',
                    _title: 'Dynamic Green+',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    $relation: {
                      entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                    }
                  }
                ],
                product_downloads: [
                  {
                    _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Datenschutz'],
                    _title: 'Datenschutzinformationen.pdf',
                    access_control: 'public-read',
                    filename: 'Datenschutzinformationen.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:20.522Z',
                    _updated_at: '2025-04-04T07:57:21.022Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                    $relation: {
                      entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                    }
                  },
                  {
                    _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'AGB'],
                    _title: 'AGB.pdf',
                    access_control: 'public-read',
                    filename: 'AGB.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:21.247Z',
                    _updated_at: '2025-04-04T07:57:21.704Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                    $relation: {
                      entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                    }
                  },
                  {
                    _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Widerrufsformular'],
                    _title: 'Muster-Widerrufsformular.pdf',
                    access_control: 'public-read',
                    filename: 'Muster-Widerrufsformular.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:21.101Z',
                    _updated_at: '2025-04-04T07:57:21.569Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                    $relation: {
                      entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                    }
                  },
                  {
                    _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Preisblatt'],
                    _title: 'Preisblatt.pdf',
                    access_control: 'public-read',
                    filename: 'Preisblatt.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:20.386Z',
                    _updated_at: '2025-04-04T07:57:20.823Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                    $relation: {
                      entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                    }
                  }
                ],
                product_images: [],
                type: 'product',
                _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                _title: 'Strom Green+',
                _messages: {}
              },
              taxes: [
                {
                  tax: {
                    _manifest: [
                      '956e9f44-0d8e-4d50-af85-e528fb130d64',
                      'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                      '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                      '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                      '4573c148-9fa1-4de8-bb05-964a01690789'
                    ],
                    _schema: 'tax',
                    active: true,
                    description: '19%',
                    rate: '19',
                    region: 'DE',
                    type: 'VAT',
                    _id: '170d696a-611a-4627-a904-137741027989',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:09:29.464Z',
                    _updated_at: '2025-04-04T07:57:19.848Z',
                    _title: '19%',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    }
                  },
                  amount: 0
                }
              ],
              type: 'recurring',
              billing_period: 'monthly',
              unit_amount_net: 20,
              unit_amount_gross: 24,
              amount_subtotal: 0,
              amount_total: 0,
              amount_tax: 0,
              dynamic_tariff: {
                interval: 'hourly',
                markup: 0,
                markup_amount: 15,
                markup_amount_decimal: '0.1511',
                markup_decimal: '0.00',
                mode: 'day_ahead_market',
                markup_amount_net: 13,
                markup_amount_gross: 15,
                unit_amount_net: 8,
                unit_amount_gross: 9,
                unit_amount_net_decimal: '0.0779',
                unit_amount_gross_decimal: '0.092701',
                markup_amount_net_decimal: '0.126974789916',
                markup_amount_gross_decimal: '0.1511'
              },
              currency: 'EUR',
              is_tax_inclusive: true,
              unit_amount_net_decimal: '0.204874789916',
              unit_amount_gross_decimal: '0.243801',
              amount_subtotal_decimal: '0',
              amount_total_decimal: '0'
            },
            {
              price_id: '9341c8ea-0245-4e32-b771-6b0290428e51',
              product_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
              quantity: 1,
              description: 'Umlagen, Abgaben, Steuern, etc.',
              unit_amount: 16,
              unit_amount_decimal: '0.1611',
              pricing_model: 'per_unit',
              _price: {
                _id: '9341c8ea-0245-4e32-b771-6b0290428e51',
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _tags: ['Commodity', 'Strom'],
                active: true,
                billing_duration_unit: 'months',
                description: 'Umlagen, Abgaben, Steuern, etc.',
                is_tax_inclusive: true,
                notice_time_unit: 'months',
                price_display_in_journeys: 'show_price',
                pricing_model: 'per_unit',
                renewal_duration_unit: 'months',
                tax: [
                  {
                    _manifest: [
                      '956e9f44-0d8e-4d50-af85-e528fb130d64',
                      'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                      '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                      '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                      '4573c148-9fa1-4de8-bb05-964a01690789'
                    ],
                    _schema: 'tax',
                    active: true,
                    description: '19%',
                    rate: '19',
                    region: 'DE',
                    type: 'VAT',
                    _id: '170d696a-611a-4627-a904-137741027989',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:09:29.464Z',
                    _updated_at: '2025-04-04T07:57:19.848Z',
                    _title: '19%',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    }
                  }
                ],
                termination_time_unit: 'months',
                tiers: [],
                type: 'recurring',
                unit: 'kwh',
                unit_amount: 16,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0.1611',
                variable_price: true,
                billing_period: 'monthly',
                internal_description: 'Umlagen, Abgaben, Steuern, etc.',
                _title: 'Umlagen, Abgaben, Steuern, etc.',
                averageMarketPrice: {
                  market: 'day_ahead',
                  bidding_zone: 'DE-LU',
                  price: {
                    timestamp:
                      '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
                    unit_amount: 7.79,
                    unit_amount_decimal: '0.0779',
                    unit_amount_currency: 'EUR'
                  },
                  _meta: {
                    timestamp: 1747981644144,
                    signature:
                      'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
                  },
                  inputs: {
                    market: 'day_ahead',
                    bidding_zone: 'DE-LU',
                    from: '2025-04-01',
                    to: '2025-04-30'
                  }
                }
              },
              _product: {
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _tags: ['Commodity', 'Strom', 'dont-touch'],
                active: true,
                categories: [],
                description: 'Außerhalb der Grundversorgung',
                feature: [
                  {
                    _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                    _tags: [],
                    feature: '100% Ökostrom',
                    value: ''
                  },
                  {
                    _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                    _tags: [],
                    feature: 'Erstlaufzeit bis 31.12.2025',
                    value: ''
                  },
                  {
                    _id: 'SbRtgtY6flxvlR1M-LaHi',
                    _tags: [],
                    feature: 'Kündigungsfrist 1 Monat',
                    value: ''
                  },
                  {
                    _id: 'v07rw_RfinlcUOfQD0h9S',
                    _tags: [],
                    feature:
                      '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                    value: ''
                  }
                ],
                internal_name: 'Strom Green+',
                name: 'Strom Green+',
                price_options: [
                  {
                    _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _schema: 'price',
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    description: 'Classic Green+',
                    is_composite_price: true,
                    is_tax_inclusive: null,
                    price_components: [],
                    price_display_in_journeys: 'show_price',
                    pricing_model: null,
                    tiers: [],
                    type: null,
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: null,
                    billing_duration_amount: null,
                    billing_duration_unit: null,
                    billing_period: null,
                    internal_description: 'Classic Green+',
                    notice_time_amount: null,
                    notice_time_unit: null,
                    renewal_duration_amount: null,
                    renewal_duration_unit: null,
                    termination_time_amount: null,
                    termination_time_unit: null,
                    unit: null,
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:27.709Z',
                    _updated_at: '2025-05-23T06:23:55.130Z',
                    _title: 'Classic Green+',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    $relation: {
                      entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                    }
                  },
                  {
                    _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                    _schema: 'price',
                    _tags: ['Commodity', 'Strom'],
                    active: true,
                    billing_duration_unit: 'months',
                    description: 'Dynamic Green+',
                    is_composite_price: true,
                    is_tax_inclusive: true,
                    notice_time_unit: 'months',
                    price_components: [],
                    price_display_in_journeys: 'show_price',
                    pricing_model: 'per_unit',
                    renewal_duration_unit: 'months',
                    termination_time_unit: 'months',
                    tiers: [],
                    type: 'one_time',
                    unit_amount: 0,
                    unit_amount_currency: 'EUR',
                    unit_amount_decimal: '0.00',
                    variable_price: false,
                    billing_period: 'weekly',
                    internal_description: 'Dynamic Green+',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:27.918Z',
                    _updated_at: '2025-05-23T06:24:15.056Z',
                    _title: 'Dynamic Green+',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    $relation: {
                      entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                    }
                  }
                ],
                product_downloads: [
                  {
                    _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Datenschutz'],
                    _title: 'Datenschutzinformationen.pdf',
                    access_control: 'public-read',
                    filename: 'Datenschutzinformationen.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Datenschutz'],
                        _title: 'Datenschutzinformationen.pdf',
                        access_control: 'public-read',
                        filename: 'Datenschutzinformationen.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:20.522Z',
                    _updated_at: '2025-04-04T07:57:21.022Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                    $relation: {
                      entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                    }
                  },
                  {
                    _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'AGB'],
                    _title: 'AGB.pdf',
                    access_control: 'public-read',
                    filename: 'AGB.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'AGB'],
                        _title: 'AGB.pdf',
                        access_control: 'public-read',
                        filename: 'AGB.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:21.247Z',
                    _updated_at: '2025-04-04T07:57:21.704Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                    $relation: {
                      entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                    }
                  },
                  {
                    _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Widerrufsformular'],
                    _title: 'Muster-Widerrufsformular.pdf',
                    access_control: 'public-read',
                    filename: 'Muster-Widerrufsformular.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Widerrufsformular'],
                        _title: 'Muster-Widerrufsformular.pdf',
                        access_control: 'public-read',
                        filename: 'Muster-Widerrufsformular.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:21.101Z',
                    _updated_at: '2025-04-04T07:57:21.569Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                    $relation: {
                      entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                    }
                  },
                  {
                    _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Preisblatt'],
                    _title: 'Preisblatt.pdf',
                    access_control: 'public-read',
                    filename: 'Preisblatt.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                    },
                    versions: [
                      {
                        _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                        _purpose: [],
                        _tags: ['Commodity', 'Preisblatt'],
                        _title: 'Preisblatt.pdf',
                        access_control: 'public-read',
                        filename: 'Preisblatt.pdf',
                        mime_type: 'application/pdf',
                        type: 'document',
                        category: 'unknown',
                        file_entity_id: '',
                        size_bytes: 11451,
                        readable_size: '11.18 KB',
                        public_url:
                          'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                        s3ref: {
                          bucket: 'epilot-prod-user-content',
                          key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                        }
                      }
                    ],
                    _schema: 'file',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:57:20.386Z',
                    _updated_at: '2025-04-04T07:57:20.823Z',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    },
                    source_url:
                      'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                    $relation: {
                      entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                    }
                  }
                ],
                product_images: [],
                type: 'product',
                _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
                _title: 'Strom Green+',
                _messages: {}
              },
              taxes: [
                {
                  tax: {
                    _manifest: [
                      '956e9f44-0d8e-4d50-af85-e528fb130d64',
                      'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                      '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                      '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                      '4573c148-9fa1-4de8-bb05-964a01690789'
                    ],
                    _schema: 'tax',
                    active: true,
                    description: '19%',
                    rate: '19',
                    region: 'DE',
                    type: 'VAT',
                    _id: '170d696a-611a-4627-a904-137741027989',
                    _org: 'test-org',
                    _owners: [
                      {
                        org_id: '16246022',
                        user_id: '140034'
                      }
                    ],
                    _created_at: '2025-04-04T07:09:29.464Z',
                    _updated_at: '2025-04-04T07:57:19.848Z',
                    _title: '19%',
                    _acl: {
                      view: ['org_16246022'],
                      edit: ['org_16246022'],
                      delete: ['org_16246022']
                    }
                  },
                  amount: 0
                }
              ],
              type: 'recurring',
              billing_period: 'monthly',
              unit_amount_net: 14,
              unit_amount_gross: 16,
              amount_subtotal: 0,
              amount_total: 0,
              amount_tax: 0,
              currency: 'EUR',
              is_tax_inclusive: true,
              unit_amount_net_decimal: '0.135378151261',
              unit_amount_gross_decimal: '0.1611',
              amount_subtotal_decimal: '0',
              amount_total_decimal: '0'
            }
          ],
          _price: {
            _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
            _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
            _tags: ['Commodity', 'Strom'],
            active: true,
            billing_duration_unit: 'months',
            description: 'Dynamic Green+',
            is_composite_price: true,
            is_tax_inclusive: true,
            notice_time_unit: 'months',
            price_components: [
              {
                _id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
                _manifest: [
                  '3babbfe8-80a2-4e19-b9e6-3d6d4fa22730',
                  '50fb9921-3b0d-430a-9211-5b741e601008',
                  '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                  '4573c148-9fa1-4de8-bb05-964a01690789'
                ],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _tags: ['Commodity', 'Strom'],
                active: true,
                description: 'Grundpreis',
                is_tax_inclusive: true,
                price_display_in_journeys: 'show_price',
                pricing_model: 'tiered_volume',
                tax: {
                  $relation: [
                    {
                      entity_id: '170d696a-611a-4627-a904-137741027989'
                    }
                  ]
                },
                tiers: [],
                type: 'recurring',
                unit_amount: 1300,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '13',
                variable_price: true,
                billing_duration_amount: '',
                billing_duration_unit: null,
                billing_period: 'monthly',
                internal_description: 'Grundpreis',
                notice_time_amount: null,
                notice_time_unit: null,
                price_components: null,
                renewal_duration_amount: null,
                renewal_duration_unit: null,
                termination_time_amount: null,
                termination_time_unit: null,
                _title: 'Grundpreis'
              },
              {
                _id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _tags: ['Commodity', 'Strom'],
                active: true,
                billing_duration_unit: 'months',
                description: 'Energie Spotmarktpreis',
                is_tax_inclusive: true,
                notice_time_unit: 'months',
                price_display_in_journeys: 'show_price',
                pricing_model: 'dynamic_tariff',
                renewal_duration_unit: 'months',
                tax: {
                  $relation: [
                    {
                      entity_id: '170d696a-611a-4627-a904-137741027989'
                    }
                  ]
                },
                termination_time_unit: 'months',
                tiers: [],
                type: 'recurring',
                unit: 'kwh',
                unit_amount: 0,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0.00',
                variable_price: true,
                billing_period: 'monthly',
                dynamic_tariff: {
                  interval: 'hourly',
                  markup: 0,
                  markup_amount: 15,
                  markup_amount_decimal: '0.1511',
                  markup_decimal: '0.00',
                  mode: 'day_ahead_market'
                },
                internal_description: 'Energie Spotmarktpreis',
                _title: 'Energie Spotmarktpreis'
              },
              {
                _id: '9341c8ea-0245-4e32-b771-6b0290428e51',
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _tags: ['Commodity', 'Strom'],
                active: true,
                billing_duration_unit: 'months',
                description: 'Umlagen, Abgaben, Steuern, etc.',
                is_tax_inclusive: true,
                notice_time_unit: 'months',
                price_display_in_journeys: 'show_price',
                pricing_model: 'per_unit',
                renewal_duration_unit: 'months',
                tax: {
                  $relation: [
                    {
                      entity_id: '170d696a-611a-4627-a904-137741027989'
                    }
                  ]
                },
                termination_time_unit: 'months',
                tiers: [],
                type: 'recurring',
                unit: 'kwh',
                unit_amount: 16,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0.1611',
                variable_price: true,
                billing_period: 'monthly',
                internal_description: 'Umlagen, Abgaben, Steuern, etc.',
                _title: 'Umlagen, Abgaben, Steuern, etc.'
              }
            ],
            price_display_in_journeys: 'show_price',
            pricing_model: 'per_unit',
            renewal_duration_unit: 'months',
            termination_time_unit: 'months',
            tiers: [],
            type: 'one_time',
            unit_amount: 0,
            unit_amount_currency: 'EUR',
            unit_amount_decimal: '0.00',
            variable_price: false,
            billing_period: 'weekly',
            internal_description: 'Dynamic Green+',
            _title: 'Dynamic Green+'
          },
          _product: {
            _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
            _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
            _tags: ['Commodity', 'Strom', 'dont-touch'],
            active: true,
            categories: [],
            description: 'Außerhalb der Grundversorgung',
            feature: [
              {
                _id: 'Y_QjVZ9MHTf8KCp4RFBeW',
                _tags: [],
                feature: '100% Ökostrom',
                value: ''
              },
              {
                _id: 'N7NMWrgGgYqmIHs-Jt6Hq',
                _tags: [],
                feature: 'Erstlaufzeit bis 31.12.2025',
                value: ''
              },
              {
                _id: 'SbRtgtY6flxvlR1M-LaHi',
                _tags: [],
                feature: 'Kündigungsfrist 1 Monat',
                value: ''
              },
              {
                _id: 'v07rw_RfinlcUOfQD0h9S',
                _tags: [],
                feature:
                  '100 % Preisgarantie auf den Energiepreis (ausgenommen Netzentgelte, Umlagen/Steuern)',
                value: ''
              }
            ],
            internal_name: 'Strom Green+',
            name: 'Strom Green+',
            price_options: [
              {
                _id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8',
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _schema: 'price',
                _tags: ['Commodity', 'Strom'],
                active: true,
                description: 'Classic Green+',
                is_composite_price: true,
                is_tax_inclusive: null,
                price_components: [],
                price_display_in_journeys: 'show_price',
                pricing_model: null,
                tiers: [],
                type: null,
                unit_amount: 0,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0.00',
                variable_price: null,
                billing_duration_amount: null,
                billing_duration_unit: null,
                billing_period: null,
                internal_description: 'Classic Green+',
                notice_time_amount: null,
                notice_time_unit: null,
                renewal_duration_amount: null,
                renewal_duration_unit: null,
                termination_time_amount: null,
                termination_time_unit: null,
                unit: null,
                _org: 'test-org',
                _owners: [
                  {
                    org_id: '16246022',
                    user_id: '140034'
                  }
                ],
                _created_at: '2025-04-04T07:57:27.709Z',
                _updated_at: '2025-05-23T06:23:55.130Z',
                _title: 'Classic Green+',
                _acl: {
                  view: ['org_16246022'],
                  edit: ['org_16246022'],
                  delete: ['org_16246022']
                },
                $relation: {
                  entity_id: '1c272ef0-0dd9-4270-8df0-f2298d9adbc8'
                }
              },
              {
                _id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
                _schema: 'price',
                _tags: ['Commodity', 'Strom'],
                active: true,
                billing_duration_unit: 'months',
                description: 'Dynamic Green+',
                is_composite_price: true,
                is_tax_inclusive: true,
                notice_time_unit: 'months',
                price_components: [],
                price_display_in_journeys: 'show_price',
                pricing_model: 'per_unit',
                renewal_duration_unit: 'months',
                termination_time_unit: 'months',
                tiers: [],
                type: 'one_time',
                unit_amount: 0,
                unit_amount_currency: 'EUR',
                unit_amount_decimal: '0.00',
                variable_price: false,
                billing_period: 'weekly',
                internal_description: 'Dynamic Green+',
                _org: 'test-org',
                _owners: [
                  {
                    org_id: '16246022',
                    user_id: '140034'
                  }
                ],
                _created_at: '2025-04-04T07:57:27.918Z',
                _updated_at: '2025-05-23T06:24:15.056Z',
                _title: 'Dynamic Green+',
                _acl: {
                  view: ['org_16246022'],
                  edit: ['org_16246022'],
                  delete: ['org_16246022']
                },
                $relation: {
                  entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac'
                }
              }
            ],
            product_downloads: [
              {
                _id: '26495f53-c961-4214-a417-9a7b05e039a1',
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: [],
                _tags: ['Commodity', 'Datenschutz'],
                _title: 'Datenschutzinformationen.pdf',
                access_control: 'public-read',
                filename: 'Datenschutzinformationen.pdf',
                mime_type: 'application/pdf',
                type: 'document',
                category: 'unknown',
                file_entity_id: '',
                size_bytes: 11451,
                readable_size: '11.18 KB',
                public_url:
                  'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                s3ref: {
                  bucket: 'epilot-prod-user-content',
                  key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                },
                versions: [
                  {
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Datenschutz'],
                    _title: 'Datenschutzinformationen.pdf',
                    access_control: 'public-read',
                    filename: 'Datenschutzinformationen.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/4e4e92d5-3e4d-4d69-98ca-fe74f187a3d9/Datenschutzinformationen.pdf'
                    }
                  }
                ],
                _schema: 'file',
                _org: 'test-org',
                _owners: [
                  {
                    org_id: '16246022',
                    user_id: '140034'
                  }
                ],
                _created_at: '2025-04-04T07:57:20.522Z',
                _updated_at: '2025-04-04T07:57:21.022Z',
                _acl: {
                  view: ['org_16246022'],
                  edit: ['org_16246022'],
                  delete: ['org_16246022']
                },
                source_url:
                  'https://file.sls.epilot.io/v1/files/public/links/16246022-Hkq5YeyLmoSFDchcTPpgf/Datenschutzinformationen.pdf?hash=7366205b',
                $relation: {
                  entity_id: '26495f53-c961-4214-a417-9a7b05e039a1'
                }
              },
              {
                _id: '570756ec-796f-41b7-981c-e731ef4905ef',
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: [],
                _tags: ['Commodity', 'AGB'],
                _title: 'AGB.pdf',
                access_control: 'public-read',
                filename: 'AGB.pdf',
                mime_type: 'application/pdf',
                type: 'document',
                category: 'unknown',
                file_entity_id: '',
                size_bytes: 11451,
                readable_size: '11.18 KB',
                public_url:
                  'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                s3ref: {
                  bucket: 'epilot-prod-user-content',
                  key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                },
                versions: [
                  {
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'AGB'],
                    _title: 'AGB.pdf',
                    access_control: 'public-read',
                    filename: 'AGB.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/ec39341e-69c6-4710-bf29-90c115ad125a/AGB.pdf'
                    }
                  }
                ],
                _schema: 'file',
                _org: 'test-org',
                _owners: [
                  {
                    org_id: '16246022',
                    user_id: '140034'
                  }
                ],
                _created_at: '2025-04-04T07:57:21.247Z',
                _updated_at: '2025-04-04T07:57:21.704Z',
                _acl: {
                  view: ['org_16246022'],
                  edit: ['org_16246022'],
                  delete: ['org_16246022']
                },
                source_url:
                  'https://file.sls.epilot.io/v1/files/public/links/16246022-5swXE8Enc6-0QGm6c7Dyv/AGB.pdf?hash=8a6c884a',
                $relation: {
                  entity_id: '570756ec-796f-41b7-981c-e731ef4905ef'
                }
              },
              {
                _id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26',
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: [],
                _tags: ['Commodity', 'Widerrufsformular'],
                _title: 'Muster-Widerrufsformular.pdf',
                access_control: 'public-read',
                filename: 'Muster-Widerrufsformular.pdf',
                mime_type: 'application/pdf',
                type: 'document',
                category: 'unknown',
                file_entity_id: '',
                size_bytes: 11451,
                readable_size: '11.18 KB',
                public_url:
                  'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                s3ref: {
                  bucket: 'epilot-prod-user-content',
                  key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                },
                versions: [
                  {
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Widerrufsformular'],
                    _title: 'Muster-Widerrufsformular.pdf',
                    access_control: 'public-read',
                    filename: 'Muster-Widerrufsformular.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/744c4804-172b-4b3e-aab4-1dfb984b9e07/Muster-Widerrufsformular.pdf'
                    }
                  }
                ],
                _schema: 'file',
                _org: 'test-org',
                _owners: [
                  {
                    org_id: '16246022',
                    user_id: '140034'
                  }
                ],
                _created_at: '2025-04-04T07:57:21.101Z',
                _updated_at: '2025-04-04T07:57:21.569Z',
                _acl: {
                  view: ['org_16246022'],
                  edit: ['org_16246022'],
                  delete: ['org_16246022']
                },
                source_url:
                  'https://file.sls.epilot.io/v1/files/public/links/16246022-wMp5naqu_tVMCIuPVqbKi/Muster-Widerrufsformular.pdf?hash=5205db46',
                $relation: {
                  entity_id: 'e2b16210-b2c0-4f4d-9928-6d7d1e698c26'
                }
              },
              {
                _id: 'b7f54c75-3569-4ca3-b47f-a727c4339225',
                _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                _purpose: [],
                _tags: ['Commodity', 'Preisblatt'],
                _title: 'Preisblatt.pdf',
                access_control: 'public-read',
                filename: 'Preisblatt.pdf',
                mime_type: 'application/pdf',
                type: 'document',
                category: 'unknown',
                file_entity_id: '',
                size_bytes: 11451,
                readable_size: '11.18 KB',
                public_url:
                  'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                s3ref: {
                  bucket: 'epilot-prod-user-content',
                  key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                },
                versions: [
                  {
                    _manifest: ['4573c148-9fa1-4de8-bb05-964a01690789'],
                    _purpose: [],
                    _tags: ['Commodity', 'Preisblatt'],
                    _title: 'Preisblatt.pdf',
                    access_control: 'public-read',
                    filename: 'Preisblatt.pdf',
                    mime_type: 'application/pdf',
                    type: 'document',
                    category: 'unknown',
                    file_entity_id: '',
                    size_bytes: 11451,
                    readable_size: '11.18 KB',
                    public_url:
                      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf',
                    s3ref: {
                      bucket: 'epilot-prod-user-content',
                      key: '16246022/5cedcf68-eb35-45a3-981d-dffdbbce9000/Preisblatt.pdf'
                    }
                  }
                ],
                _schema: 'file',
                _org: 'test-org',
                _owners: [
                  {
                    org_id: '16246022',
                    user_id: '140034'
                  }
                ],
                _created_at: '2025-04-04T07:57:20.386Z',
                _updated_at: '2025-04-04T07:57:20.823Z',
                _acl: {
                  view: ['org_16246022'],
                  edit: ['org_16246022'],
                  delete: ['org_16246022']
                },
                source_url:
                  'https://file.sls.epilot.io/v1/files/public/links/16246022-KX328veXpqPbVd1_ph0ci/Preisblatt.pdf?hash=71802cbe',
                $relation: {
                  entity_id: 'b7f54c75-3569-4ca3-b47f-a727c4339225'
                }
              }
            ],
            product_images: [],
            type: 'product',
            _id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
            _title: 'Strom Green+',
            _messages: {}
          },
          external_price_metadata: {
            market: 'day_ahead',
            bidding_zone: 'DE-LU',
            price: {
              timestamp:
                '2025-04-01T00:00:00.000+02:00/2025-04-30T23:59:59.999+02:00',
              unit_amount: 7.79,
              unit_amount_decimal: '0.0779',
              unit_amount_currency: 'EUR'
            },
            _meta: {
              timestamp: 1747981644144,
              signature:
                'f391184cf47d00e988962261f36b7b47dc8169298ec11a04c52c0bb16af49c48'
            },
            inputs: {
              market: 'day_ahead',
              bidding_zone: 'DE-LU',
              from: '2025-04-01',
              to: '2025-04-30'
            }
          },
          external_fees_mappings: [
            {
              price_id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
              amount_total: 7.79,
              amount_total_decimal: '0.0779'
            }
          ],
          price_mappings: [
            {
              price_id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
              value: 0
            },
            {
              price_id: '14ea6011-d5b5-40a0-87cb-6ba7f8454f26',
              value: 0
            },
            {
              price_id: '9341c8ea-0245-4e32-b771-6b0290428e51',
              value: 0
            }
          ],
          currency: 'EUR',
          amount_subtotal: 0,
          amount_total: 0,
          total_details: {
            amount_tax: 0,
            breakdown: {
              taxes: [
                {
                  tax: {
                    _id: '170d696a-611a-4627-a904-137741027989',
                    type: 'VAT',
                    rate: '19'
                  },
                  amount: 0
                }
              ],
              recurrences: [
                {
                  type: 'recurring',
                  billing_period: 'monthly',
                  unit_amount_gross: 40,
                  amount_subtotal: 0,
                  amount_total: 0,
                  amount_subtotal_decimal: '0',
                  amount_total_decimal: '0',
                  amount_tax: 0
                }
              ],
              recurrencesByTax: [
                {
                  type: 'recurring',
                  billing_period: 'monthly',
                  amount_total: 0,
                  amount_subtotal: 0,
                  amount_tax: 0,
                  tax: {
                    tax: {
                      _id: '170d696a-611a-4627-a904-137741027989',
                      type: 'VAT',
                      rate: '19'
                    },
                    amount: 0
                  }
                }
              ],
              cashbacks: []
            }
          },
          amount_tax: 0,
          amount_subtotal_decimal: '0',
          amount_total_decimal: '0'
        }
      ],
      amount_subtotal: 0,
      amount_total: 0,
      total_details: {
        amount_tax: 0,
        breakdown: {
          taxes: [
            {
              tax: {
                _id: '170d696a-611a-4627-a904-137741027989',
                type: 'VAT',
                rate: '19'
              },
              amount: 0
            }
          ],
          recurrences: [
            {
              type: 'recurring',
              billing_period: 'monthly',
              unit_amount_gross: 40,
              amount_subtotal: 0,
              amount_total: 0,
              amount_subtotal_decimal: '0',
              amount_total_decimal: '0',
              amount_tax: 0
            }
          ],
          recurrencesByTax: [
            {
              type: 'recurring',
              billing_period: 'monthly',
              amount_total: 0,
              amount_subtotal: 0,
              amount_tax: 0,
              tax: {
                tax: {
                  _id: '170d696a-611a-4627-a904-137741027989',
                  type: 'VAT',
                  rate: '19'
                },
                amount: 0
              }
            }
          ],
          cashbacks: []
        }
      },
      currency: 'EUR',
      redeemed_promos: [],
      start_date: '2025-01-01',
      end_date: null,
      _tags: ['dont-touch'],
      amount_tax: 0,
      prices: {
        $relation: [
          {
            entity_id: '3ddb1a39-679f-4611-9f03-197fff12b6ac',
            _schema: 'price',
            _tags: []
          }
        ]
      },
      products: {
        $relation: [
          {
            entity_id: 'f681e4ab-e700-4c8a-9917-943a0f927dde',
            _schema: 'product',
            _tags: []
          }
        ]
      },
      notice_time_amount: '2',
      billing_address: {
        $relation_ref: [
          {
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            path: 'address',
            _id: 'L6sB14Iori1DB0PodxizK'
          }
        ]
      },
      delivery_address: [
        {
          _id: '9RpwXqqpoKV9QkrJiJ7sV',
          _tags: [],
          street: 'Adolf-Fischer-Str.',
          zip: '',
          city: 'Köln',
          country: 'DE',
          additional_info: 'Penthouse',
          postal_code: '50670',
          street_number: '2'
        }
      ],
      payment: {
        $relation_ref: [
          {
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            path: 'payment',
            _id: 'UvxxbZ13mCnwchDZxheL8'
          }
        ]
      }
    },
    {
      salutation: null,
      first_name: 'Bilal',
      last_name: 'Sengöz',
      customer_number: '1234567890',
      birthdate: '1982-08-01',
      email: [
        {
          _id: 'J_R9DRG98WrtoIojAMT0Y',
          _tags: [],
          email: 'user@example.com',
          id: 'k12tnv9'
        }
      ],
      phone: [
        {
          _id: 'pYiiEvUjLZM7DG-40Zu2O',
          _tags: [],
          phone: '012341234123',
          id: 'u3kn97s'
        }
      ],
      address: [
        {
          _id: 'b9bwop8ILRikGedEo72qU',
          _tags: ['delivery', 'billing'],
          street: 'Adolf-Fischer-Str.',
          zip: '',
          city: 'Köln',
          country: 'DE',
          postal_code: '50670',
          street_number: '2',
          additional_info: 'EG Links',
          id: 'lkbjrlh'
        }
      ],
      _schema: 'contact',
      _id: '6fd04058-92c9-43bc-ab10-29a2d6808be3',
      _org: 'test-org',
      _created_at: '2025-05-19T11:01:09.452Z',
      _updated_at: '2025-06-11T11:32:16.975Z',
      _title: 'Bilal Sengöz',
      consent_email_marketing: {
        status: 'unknown',
        identifiers: [
          {
            identifier: 'user@example.com',
            status: 'unknown'
          }
        ]
      },
      consent_sms_marketing: {
        status: 'active',
        identifiers: [
          {
            identifier: '012341234123',
            status: 'active'
          }
        ]
      },
      consent_phone_call: {
        status: 'active',
        identifiers: [
          {
            identifier: '012341234123',
            status: 'active'
          }
        ]
      },
      consent_print_marketing: {
        status: 'unknown',
        identifiers: [
          {
            identifier: '6fd04058-92c9-43bc-ab10-29a2d6808be3',
            status: 'unknown'
          }
        ]
      },
      _tags: ['dont-touch'],
      first_ecp_login: '2025-05-20T07:25:29.779Z',
      payment: null,
      _pending_changes: {},
      journey_actions: [],
      files: [],
      language: 'de'
    }
  ],
  journey_actions: []
}
